(() => {
  if (customElements.get('bdl-disc-search')) return;
  const quote = (value) => value.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  const unquote = (value) => value.replace(/\\([\\"])/g, '$1');
  const compose = (keyword, brand) => {
    const text = keyword.trim();
    const name = text && text !== '*' ? `title:"${quote(text)}"` : '';
    const scope = brand ? `vendor:"${quote(brand)}"` : '';
    return [name, scope].filter(Boolean).join(' AND ') || '*';
  };
  const parse = (query, brands) => {
    const named = query.match(/^title:"((?:\\.|[^"\\])*)"(?: AND vendor:"((?:\\.|[^"\\])*)")?$/);
    if (named) {
      const brand = named[2] ? unquote(named[2]) : '';
      if (!brand || brands.includes(brand)) return { keyword: unquote(named[1]), brand };
    }
    const grouped = query.match(/^\(([\s\S]*)\) AND vendor:"((?:\\.|[^"\\])*)"$/);
    const only = query.match(/^vendor:"((?:\\.|[^"\\])*)"$/);
    const match = grouped || only;
    if (match) {
      const brand = unquote(grouped ? match[2] : match[1]);
      if (brands.includes(brand)) return { keyword: grouped ? match[1] : '', brand };
    }
    return { keyword: query === '*' ? '' : query, brand: '' };
  };
  class BdlDiscSearch extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const form = this.querySelector('form');
      const keyword = this.querySelector('[data-keyword]');
      const brand = this.querySelector('[data-brand]');
      const output = this.querySelector('[data-query]');
      const availability = this.querySelector('[data-availability]');
      if (!form || !keyword || !brand || !output || !availability) return;
      this.initialized = true;
      const parsed = parse(keyword.value, Array.from(brand.options, (option) => option.value));
      keyword.value = parsed.keyword;
      brand.value = parsed.brand;
      const unavailable = new URLSearchParams(window.location.search).get('options[unavailable]');
      if (unavailable === 'hide' || unavailable === 'last') availability.value = unavailable;
      this.querySelector('[data-brand-field]').hidden = false;
      keyword.removeAttribute('name');
      output.disabled = false;
      form.addEventListener('submit', () => {
        output.value = compose(keyword.value, brand.value);
      });
    }
  }
  customElements.define('bdl-disc-search', BdlDiscSearch);
})();

